export const APP_ROUTES = {
  DASHBOARD: '/dashboard',
  PAY: '/pay',
  SAVE: '/save',
  INVEST: '/invest',
  BORROW: '/borrow',
  PROFILE: '/profile',
} as const;
